import {hasRole} from './roles';

/**
 * Première page à ouvrir après connexion, selon les modules de l'utilisateur.
 *
 * La racine redirigeait inconditionnellement vers `/dashboard`, dont `ProtectedRoute` exige
 * l'un des modules IMPORT, EXPORT, RECAP, STATS ou ADMIN. Un compte ne portant que
 * MODULE_CARBURANT et MODULE_PANNES — profil légitime, prévu par les rôles du realm et par les
 * RoleRule du backend — arrivait donc sur « Accès refusé », ses deux menus bien visibles sur le
 * côté. Le message l'invitait à contacter un administrateur alors que ses droits étaient
 * exactement ceux voulus.
 *
 * L'ordre suit celui de la barre latérale, pour que la page d'arrivée corresponde à ce que
 * l'utilisateur voit en premier dans le menu.
 *
 * <b>Ceci n'est pas un contrôle de sécurité</b> : `ProtectedRoute` garde chaque route, et le
 * backend ses `RoleRule`. On ne fait que choisir une destination sensée — un utilisateur qui
 * forcerait une URL se heurterait aux mêmes refus qu'avant.
 */

/** Page affichée à un compte sans aucun module — distincte d'un refus d'accès. */
export const ROUTE_SANS_MODULE = '/aucun-module';

interface Etape {
    route: string;
    modules: string[];
}

/**
 * Le tableau de bord passe en premier : il couvre la majorité des profils de back-office, et
 * reste la page d'accueil naturelle pour eux. Les entrées suivantes reprennent l'ordre du menu
 * — menus groupés (Import, Export, Carburant, Pannes) puis entrées simples.
 */
const ETAPES: Etape[] = [
    {route: '/dashboard', modules: ['MODULE_IMPORT', 'MODULE_EXPORT', 'MODULE_RECAP', 'MODULE_STATS', 'MODULE_ADMIN']},
    {route: '/carburant', modules: ['MODULE_CARBURANT']},
    {route: '/pannes', modules: ['MODULE_PANNES']},
    {route: '/documents-camion', modules: ['MODULE_DOCUMENTS']},
    {route: '/gestion-parc', modules: ['MODULE_PARC']},
    {route: '/referentiels/armateurs', modules: ['MODULE_REGLAGES']},
];

export const routeAccueil = (user: any): string => {
    const etape = ETAPES.find(e => hasRole(user, ...e.modules));
    return etape ? etape.route : ROUTE_SANS_MODULE;
};
